import axios from 'axios'
import { getToken, setToken } from '@b/utils/auth'
import Swal from 'sweetalert2'
import store from '@b/store'

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  baseURL: '/api/backend/',
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['Accept'] = 'application/json'
    let token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token // Set token
    }else if(store.getters.token){
      config.headers['Authorization'] = 'Bearer ' + store.getters.token
    }else{

    }

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug

    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    
    if(response.data.code != 200){
      
    }

    return response
  },
  error => {
    console.log('err' + error) // for debug
    
    return Promise.reject(error)
  }
)

export default service
